import React, { useState, useEffect } from 'react';
import { db, auth, googleProvider } from '../firebaseConfig';
import { signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
import { collection, onSnapshot, deleteDoc, doc, updateDoc, query, setDoc, orderBy, serverTimestamp } from 'firebase/firestore';
import Logo from '../components/Logo';
import axios from 'axios';

const SuperAdmin = () => {
  const [activeTab, setActiveTab] = useState('onay'); // Sayfa açılınca direkt "Onay Bekleyenler" açılsın
  const [tesisler, setTesisler] = useState([]);
  const [bekleyenTesisler, setBekleyenTesisler] = useState([]);

  const [odemeler, setOdemeler] = useState([]); // Tüm finansal kayıtlar
  const [goller, setGoller] = useState([]); // Atılan goller
  const [blockedUsers, setBlockedUsers] = useState([]); // Engellenenler
  const [users, setUsers] = useState([]); // Kayıtlı kullanıcılar
  const [userProfiles, setUserProfiles] = useState({}); // Kullanıcı profilleri
  const [newSahaEmail, setNewSahaEmail] = useState("");
  const [newSahaName, setNewSahaName] = useState("");
  const [newSahaFirstName, setNewSahaFirstName] = useState("");
  const [newSahaLastName, setNewSahaLastName] = useState("");
  const [newSahaPhone, setNewSahaPhone] = useState("");
  const [isAddingSaha, setIsAddingSaha] = useState(false);
  const [seciliYil, setSeciliYil] = useState(new Date().getFullYear());
  const [seciliAy, setSeciliAy] = useState(new Date().getMonth() + 1);
  const [showSidebar, setShowSidebar] = useState(false); // Mobil menü kontrolü

  // --- SÜPER ADMİN EKLEME YENİ STATE'LER ---
  const [superadmins, setSuperadmins] = useState([]);
  const [newAdminUsername, setNewAdminUsername] = useState("");
  const [newAdminEmail, setNewAdminEmail] = useState("");
  const [newAdminPassword, setNewAdminPassword] = useState("");
  const [newAdminName, setNewAdminName] = useState("");
  const [newAdminSurname, setNewAdminSurname] = useState("");
  const [newAdminCode, setNewAdminCode] = useState("");
  const [isAddingAdmin, setIsAddingAdmin] = useState(false);
  const [adminUser, setAdminUser] = useState(null);


  // eslint-disable-next-line no-unused-vars
  const adminWhitelist = ["suerdemahmetsami7@gmail.com", "admin@sahalive.com", "suerd@example.com", "deneme123@gmail.com", "sahaliveproje@gmail.com"]; // Yetkili mailler


  useEffect(() => {
    const isSuperAdminLocalCheck = localStorage.getItem("superAdmin");
    if (!isSuperAdminLocalCheck) {
      window.location.href = "/";
      return;
    }

    const unsubAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        setAdminUser(user);
      } else {
        setAdminUser(null);
      }
    });

    const unsubTesisler = onSnapshot(collection(db, "tesisler"), (snapshot) => {
       const tumSahalar = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
       setBekleyenTesisler(tumSahalar.filter(t => t.status === "pending"));
       setTesisler(tumSahalar.filter(t => t.status === "approved" || t.status === "authorized"));
     });

    const unsubOdemeler = onSnapshot(collection(db, "odemeler"), (snapshot) => {
      setOdemeler(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    const unsubGoller = onSnapshot(query(collection(db, "goller"), orderBy("createdAt", "desc")), (snapshot) => {
      setGoller(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    const unsubBlocked = onSnapshot(collection(db, "blockedUsers"), (snapshot) => {
      setBlockedUsers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    const unsubUsers = onSnapshot(query(collection(db, "users"), orderBy("lastLogin", "desc")), (snapshot) => {
      setUsers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    const unsubProfiles = onSnapshot(collection(db, "userProfiles"), (snapshot) => {
      const profilesMap = {};
      snapshot.docs.forEach(doc => {
        profilesMap[doc.id] = doc.data();
      });
      setUserProfiles(profilesMap);
    });

    const fetchSuperAdmins = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/superadmins`);
        setSuperadmins(response.data);
      } catch (err) {
        console.error("Superadmins fetch error:", err);
      }
    };

    fetchSuperAdmins();

    return () => {
      unsubAuth();
      unsubTesisler();
      unsubOdemeler();
      unsubGoller();
      unsubBlocked();
      unsubUsers();
      unsubProfiles();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // --- ONAY İŞLEMLERİ ---
  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (error) {
      alert("Giriş başarısız: " + error.message);
    }
  };

  // activeReservationsCount kaldırıldı
  const handleApproveTesis = async (tesisId) => {
    if (window.confirm("Bu halı sahayı ONAYLAMAK istediğinize emin misiniz? (Kurulum yapması için yetkilendirilecektir)")) {
      try {
        await updateDoc(doc(db, "tesisler", tesisId), { status: "approved" });
        alert("Tesis başarıyla onaylandı ve yayına hazır hale getirildi!");
      } catch (error) { alert("Hata: " + error.message); }
    }
  };

  const handleRejectTesis = async (tesisId) => {
    if (window.confirm("Bu başvuruyu REDDEDİP kaydı tamamen SİLMEK istediğinize emin misiniz?")) {
      try {
        await deleteDoc(doc(db, "tesisler", tesisId));
        alert("Başvuru reddedildi ve sistemden silindi.");
      } catch (error) { alert("Hata: " + error.message); }
    }
  };

  const handleDeleteFirebase = async (koleksiyon, id) => {
    if (window.confirm("Bu sahanın sistemle ilişiğini kesmek istediğinize emin misiniz?")) {
      try { await deleteDoc(doc(db, koleksiyon, id)); }
      catch (error) { alert("Hata: " + error.message); }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("superAdmin");
    window.location.href = "/";
  };

  // --- SÜPER ADMİN EKLEME VE SİLME ---
  const handleAddSuperAdmin = async (e) => {
    e.preventDefault();
    if (!newAdminUsername || !newAdminEmail || !newAdminPassword || !newAdminCode) {
      return alert("Lütfen Kullanıcı Adı, E-posta, Şifre ve Özel Kod alanlarını doldurun!");
    }
    setIsAddingAdmin(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/superadmins`, {
        username: newAdminUsername,
        email: newAdminEmail,
        password: newAdminPassword,
        name: newAdminName,
        surname: newAdminSurname,
        superadminCode: newAdminCode
      });
      alert(response.data.message || "Süper Admin eklendi!");
      // Alanları temizle
      setNewAdminUsername("");
      setNewAdminEmail("");
      setNewAdminPassword("");
      setNewAdminName("");
      setNewAdminSurname("");
      setNewAdminCode("");
      // Yenile
      const getRes = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/superadmins`);
      setSuperadmins(getRes.data);
    } catch (err) {
      alert("Hata: " + (err.response?.data?.error || err.message));
    } finally {
      setIsAddingAdmin(false);
    }
  };

  const handleDeleteSuperAdmin = async (id, adminEmail) => {
    if (window.confirm(`${adminEmail} adresli Süper Admin'i silmek istediğinize emin misiniz?`)) {
      try {
        const response = await axios.delete(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/superadmins/${id}`);
        alert(response.data.message || "Süper admin silindi!");
        const getRes = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/superadmins`);
        setSuperadmins(getRes.data);
      } catch (err) {
        alert("Hata: " + (err.response?.data?.error || err.message));
      }
    }
  };

  // --- MODERASYON İŞLEMLERİ ---
  const handleBlockUser = async (userId, userEmail) => {
    if (window.confirm(`${userEmail} adresli kullanıcıyı engellemek istediğinize emin misiniz? Bu kullanıcı artık video yükleyemez.`)) {
      try {
        await setDoc(doc(db, "blockedUsers", userId), {
          userEmail,
          blockedAt: serverTimestamp(),
          reason: "Kötü içerik paylaşımı"
        });
        alert("Kullanıcı başarıyla engellendi.");
      } catch (error) {
        alert("Hata: " + error.message);
      }
    }
  };

  const handleUnblockUser = async (userId) => {
    if (window.confirm("Bu kullanıcının engelini kaldırmak istiyor musunuz?")) {
      try {
        await deleteDoc(doc(db, "blockedUsers", userId));
        alert("Engel kaldırıldı.");
      } catch (error) {
        alert("Hata: " + error.message);
      }
    }
  };

  const handleDeleteUser = async (userId, userEmail) => {
    if (window.confirm(`${userEmail} adresli kullanıcıyı sistemden TAMAMEN SİLMEK istediğinize emin misiniz?`)) {
      try {
        await deleteDoc(doc(db, "users", userId));
        alert("Kullanıcı başarıyla sistemden silindi.");
      } catch (error) {
        alert("Hata: " + error.message);
      }
    }
  };

  // --- FİNANSAL İŞLEMLER ---
  const handleUpdatePayment = async (tesisId, field, value) => {
    const docId = `${tesisId}_${seciliYil}_${seciliAy}`;
    const mevcutData = odemeler.find(o => o.id === docId) || { alinanOdeme: 0, beklenenFiyat: 0, durum: 'odenmedi' };

    try {
      await setDoc(doc(db, "odemeler", docId), {
        ...mevcutData,
        tesisId,
        yil: seciliYil,
        ay: seciliAy,
        [field]: value,
        sonGuncelleme: new Date()
      }, { merge: true });
    } catch (error) {
      console.error("Payment update failed:", error);
    }
  };

  const getPaymentForTesis = (tesisId) => {
    return odemeler.find(o => o.id === `${tesisId}_${seciliYil}_${seciliAy}`) || { alinanOdeme: 0, beklenenFiyat: 0, durum: 'odenmedi' };
  };

  const handleAddSahaOwner = async (e) => {
    e.preventDefault();
    if (!newSahaEmail || !newSahaName || !newSahaFirstName || !newSahaLastName || !newSahaPhone) {
      return alert("Lütfen tüm alanları (E-posta, Saha Adı, Ad, Soyad, Telefon) eksiksiz doldurunuz.");
    }
    setIsAddingSaha(true);
    try {
      const newSahaRef = doc(collection(db, "tesisler"));
      await setDoc(newSahaRef, {
        fieldName: newSahaName,
        email: newSahaEmail.trim().toLowerCase(),
        name: newSahaFirstName.trim(),
        surname: newSahaLastName.trim(),
        phone: newSahaPhone.trim(),
        status: "authorized", // "authorized" statusu ile on-boarding'e zorlayacağız
        createdAt: serverTimestamp(),
        username: "",
        password: ""
      });
      alert("Yeni Saha Sahibi Yetkilendirildi! Artık mail ile giriş yapıp tesisini kurabilir.");
      setNewSahaEmail("");
      setNewSahaName("");
      setNewSahaFirstName("");
      setNewSahaLastName("");
      setNewSahaPhone("");
    } catch (err) {
      alert("Hata: " + err.message);
    } finally {
      setIsAddingSaha(false);
    }
  };

  const ayListesi = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
  const yilListesi = [2025, 2026, 2027, 2028, 2029, 2030];


  // Muhasebe Hesaplamaları
  const aylikFiltreliOdemeler = odemeler.filter(o => o.yil === seciliYil && o.ay === seciliAy);
  const aylikToplamCiro = aylikFiltreliOdemeler.reduce((acc, curr) => acc + (Number(curr.alinanOdeme) || 0), 0);
  const yillikToplamCiro = odemeler.filter(o => o.yil === seciliYil).reduce((acc, curr) => acc + (Number(curr.alinanOdeme) || 0), 0);
  const kdvMiktari = aylikToplamCiro * 0.20;


  return (
    <div className="d-flex min-vh-100 bg-light flex-column flex-md-row">
      {/* MOBİL HEADER (Sadece mobilde görünür) */}
      <div className="bg-dark text-white p-3 d-flex d-md-none justify-content-between align-items-center shadow-sm position-sticky top-0" style={{ zIndex: 1100 }}>
        <Logo width="150px" lightText={true} />
        <div className="d-flex gap-2">
          {!adminUser && (
            <button className="btn btn-warning btn-sm fw-bold" onClick={handleGoogleLogin}>
              <i className="fab fa-google"></i>
            </button>
          )}
          <button className="btn btn-outline-warning btn-sm fw-bold shadow-sm" onClick={() => setShowSidebar(!showSidebar)}>
            <i className={`fas ${showSidebar ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>

        {/* MOBİL DROPDOWN MENÜ */}
        {showSidebar && (
          <div
            className="position-absolute start-0 w-100 bg-dark shadow-lg border-bottom border-warning border-3"
            style={{ top: '100%', zIndex: 1099, animation: 'slideDown 0.3s ease-out' }}
          >
            <style>
              {`
                @keyframes slideDown {
                  from { transform: translateY(-10px); opacity: 0; }
                  to { transform: translateY(0); opacity: 1; }
                }
                .mobile-menu-item {
                  padding: 18px 20px !important;
                  border-bottom: 1px solid #333 !important;
                  color: #ecf0f1 !important;
                  display: block !important;
                  text-decoration: none !important;
                  cursor: pointer !important;
                }
                .mobile-menu-item:active { background: #333 !important; }
                .mobile-menu-item.active { background: #f1c40f !important; color: #000 !important; font-weight: bold !important; }
              `}
            </style>
            <div className={`mobile-menu-item ${activeTab === 'onay' ? 'active' : ''}`} onClick={() => { setActiveTab('onay'); setShowSidebar(false); }}>
              <i className="fas fa-check-circle me-2"></i> Onay Bekleyenler
              {bekleyenTesisler.length > 0 && <span className="badge bg-danger rounded-pill ms-2">{bekleyenTesisler.length}</span>}
            </div>
            <div className={`mobile-menu-item ${activeTab === 'tesisler' ? 'active' : ''}`} onClick={() => { setActiveTab('tesisler'); setShowSidebar(false); }}>
              <i className="fas fa-hospital me-2"></i> Aktif Halı Sahalar
            </div>
            <div className={`mobile-menu-item ${activeTab === 'finans' ? 'active' : ''}`} onClick={() => { setActiveTab('finans'); setShowSidebar(false); }}>
              <i className="fas fa-lira-sign me-2"></i> Finansal Takip
            </div>
            <div className={`mobile-menu-item ${activeTab === 'goller' ? 'active' : ''}`} onClick={() => { setActiveTab('goller'); setShowSidebar(false); }}>
              <i className="fas fa-video me-2"></i> Gol Yönetimi
            </div>
            <div className={`mobile-menu-item ${activeTab === 'sahipler' ? 'active' : ''}`} onClick={() => { setActiveTab('sahipler'); setShowSidebar(false); }}>
              <i className="fas fa-user-shield me-2"></i> Saha Sahipleri
            </div>
            <div className={`mobile-menu-item ${activeTab === 'superadmins' ? 'active' : ''}`} onClick={() => { setActiveTab('superadmins'); setShowSidebar(false); }}>
              <i className="fas fa-users-cog me-2"></i> Süper Adminler
            </div>
            <div className="mobile-menu-item text-danger fw-bold" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt me-2"></i> Sistemden Çıkış
            </div>
          </div>
        )}
      </div>

      {/* SIDEBAR (Masaüstü için) */}
      <div className="bg-dark text-white p-4 d-none d-md-flex flex-column shadow-lg" style={{ width: '280px', position: 'fixed', height: '100vh', top: 0, left: 0, zIndex: 1000, paddingTop: '20px' }}>
        <div className="mb-4 border-bottom border-secondary pb-3">
          <Logo width="200px" lightText={true} />
          <div className="mt-2"><small className="text-warning fw-bold">P A T R O N</small></div>
          <div className="mt-3">
            {!adminUser ? (
              <button className="btn btn-warning btn-sm w-100 fw-bold shadow-sm" onClick={handleGoogleLogin}>
                <i className="fab fa-google me-2"></i> Google ile Doğrula
              </button>
            ) : (
              <div className="d-flex align-items-center gap-2 p-2 bg-secondary bg-opacity-25 rounded-3 border border-secondary">
                <img src={adminUser.photoURL} alt="P" className="rounded-circle border border-warning" style={{ width: '32px' }} />
                <div className="overflow-hidden">
                  <div className="small fw-bold text-truncate" style={{ maxWidth: '140px' }}>{adminUser.displayName}</div>
                </div>
                <button className="btn btn-sm btn-outline-light ms-auto py-0 px-1 border-0" onClick={() => signOut(auth)} title="Çıkış">
                  <i className="fas fa-sign-out-alt"></i>
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="d-flex flex-column gap-2">
          <button className={`btn text-start d-flex justify-content-between align-items-center ${activeTab === 'onay' ? 'btn-warning text-dark fw-bold' : 'btn-dark text-secondary'}`} onClick={() => setActiveTab('onay')}>
            <span>Onay Bekleyenler</span>
            {bekleyenTesisler.length > 0 && <span className="badge bg-danger rounded-pill shadow">{bekleyenTesisler.length}</span>}
          </button>
          <button className={`btn text-start ${activeTab === 'tesisler' ? 'btn-primary' : 'btn-dark text-secondary'}`} onClick={() => setActiveTab('tesisler')}>Aktif Halı Sahalar</button>
          <button className={`btn text-start ${activeTab === 'finans' ? 'btn-primary' : 'btn-dark text-secondary'}`} onClick={() => setActiveTab('finans')}>Finansal Takip</button>

          <button className={`btn text-start ${activeTab === 'goller' ? 'btn-danger' : 'btn-dark text-secondary'}`} onClick={() => setActiveTab('goller')}>Gol Yönetimi</button>
          <button className={`btn text-start ${activeTab === 'users' ? 'btn-info text-white fw-bold' : 'btn-dark text-secondary'}`} onClick={() => setActiveTab('users')}>Kayıtlı Kullanıcılar</button>
          <button className={`btn text-start ${activeTab === 'sahipler' ? 'btn-warning text-dark fw-bold' : 'btn-dark text-secondary'}`} onClick={() => setActiveTab('sahipler')}>Saha Sahipleri</button>
          <button className={`btn text-start ${activeTab === 'superadmins' ? 'btn-warning text-dark fw-bold' : 'btn-dark text-secondary'}`} onClick={() => setActiveTab('superadmins')}>Süper Adminler</button>
        </div>
        <div className="mt-auto mb-4" style={{ width: "230px" }}>
          <button className="btn btn-outline-danger w-100 fw-bold" onClick={handleLogout}>Sistemden Çıkış</button>
        </div>
      </div>

      {/* SIDEBAR BACKDROP (Mobilde Sidebar açıkken arkaya tıklandığında kapansın) */}
      {showSidebar && (
        <div
          className="d-md-none position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
          style={{ zIndex: 999 }}
          onClick={() => setShowSidebar(false)}
        ></div>
      )}

      {/* İÇERİK - Mobilde responsive margin verilmeli */}
      <div className="flex-grow-1 p-3 p-md-5 main-content-responsive">
        <style>
          {`
            @media (min-width: 768px) {
              .main-content-responsive {
                margin-left: 280px !important;
              }
            }
            @media (max-width: 767px) {
              .main-content-responsive {
                margin-left: 0 !important;
              }
            }
          `}
        </style>

        {/* ONAY BEKLEYEN TESİSLER */}
        {activeTab === 'onay' && (
          <div className="card border-0 shadow-sm rounded-4 border-warning">
            <div className="card-header bg-warning text-dark p-4 border-bottom rounded-top-4">
              <h5 className="fw-bold m-0"><i className="fas fa-hourglass-half me-2"></i>Sisteme Katılmak İçin Onay Bekleyenler</h5>
            </div>
            <div className="table-responsive p-3">
              <table className="table table-hover align-middle m-0 bg-white">
                <thead className="bg-light text-muted small">
                  <tr>
                    <th style={{ whiteSpace: 'nowrap' }}>SAHA & LOKASYON</th>
                    <th style={{ whiteSpace: 'nowrap' }}>YETKİLİ & İLETİŞİM</th>
                    <th style={{ whiteSpace: 'nowrap' }}>TESİS İMKANLARI</th>
                    <th className="text-end" style={{ whiteSpace: 'nowrap' }}>ONAY İŞLEMİ</th>
                  </tr>
                </thead>
                <tbody>
                  {bekleyenTesisler.map(t => (
                    <tr key={t.id}>
                      <td className="ps-3">
                        <div className="fw-bold fs-5 text-dark" style={{ whiteSpace: 'nowrap' }}>{t.fieldName}</div>
                        <small className="text-muted" style={{ whiteSpace: 'nowrap' }}><i className="fas fa-map-marker-alt text-danger me-1"></i>{t.city} / {t.district}</small>
                      </td>
                      <td>
                        <div className="fw-bold text-dark" style={{ whiteSpace: 'nowrap' }}>{t.name} {t.surname}</div>
                        <div className="small text-muted fw-bold" style={{ whiteSpace: 'nowrap' }}><i className="fas fa-phone-alt text-primary me-1"></i>{t.phone}</div>
                      </td>
                      <td>
                        <div className="d-flex flex-wrap gap-2" style={{ maxWidth: "300px" }}>
                          {[
                            { key: 'dus', label: 'Duş', icon: <i className="fas fa-shower"></i> },
                            { key: 'otopark', label: 'Otopark', icon: <i className="fas fa-parking"></i> },
                            { key: 'kantin', label: 'Kantin', icon: <i className="fas fa-coffee"></i> },
                            { key: 'krampon', label: 'Krampon', icon: <i className="fas fa-shoe-prints"></i> },
                            { key: 'eldiven', label: 'Eldiven', icon: <i className="fas fa-hand-paper"></i> }
                          ].map((item) => {
                            const hasIt = t.amenities?.[item.key];
                            return (
                              <div key={item.key} className="d-flex align-items-center bg-light px-2 py-1 rounded-2 border shadow-sm" style={{ fontSize: '0.7rem' }}>
                                <span className="me-1">{item.icon}</span>
                                <span className="me-1 fw-bold">{item.label}</span>
                                {hasIt ? (
                                  <i className="fas fa-check-circle text-success"></i>
                                ) : (
                                  <i className="fas fa-times-circle text-danger"></i>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </td>
                      <td className="text-end pe-3">
                        <button className="btn btn-sm btn-success fw-bold me-2 px-3 py-2 shadow-sm" onClick={() => handleApproveTesis(t.id)}>ONAYLA</button>
                        <button className="btn btn-sm btn-danger fw-bold py-2 shadow-sm" onClick={() => handleRejectTesis(t.id)}>REDDET</button>
                      </td>
                    </tr>
                  ))}
                  {bekleyenTesisler.length === 0 && (
                    <tr>
                      <td colSpan="4" className="text-center p-5">
                        <div className="text-muted fw-bold fs-5 px-3" style={{ whiteSpace: 'normal', minWidth: '200px' }}>
                          Şu an onay bekleyen kayıt yok. Arkanıza yaslanın Patron.
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

         {/* AKTİF TESİSLER (ONAYLANANLAR) */}
        {activeTab === 'tesisler' && (
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-header bg-white p-4 border-bottom">
              <h5 className="fw-bold m-0 text-success"><i className="fas fa-check-circle me-2"></i>Sistemdeki Aktif Halı Sahalar ({tesisler.filter(t => t.status === "approved").length})</h5>
            </div>
            <div className="table-responsive p-3">
              <table className="table table-hover align-middle m-0">
                <thead className="bg-light text-muted small"><tr><th>SAHA ADI</th><th>TELEFON</th><th>GİRİŞ BİLGİLERİ</th><th className="text-end">SİSTEMDEN AT</th></tr></thead>
                <tbody>
                  {tesisler.filter(t => t.status === "approved").map(t => (
                    <tr key={t.id}>
                      <td className="ps-3 fw-bold">{t.fieldName} <br /><small className="text-muted fw-normal">{t.city}/{t.district}</small></td>
                      <td className="fw-bold text-muted">{t.phone}</td>
                      <td>
                        <div className="bg-light p-2 rounded border d-inline-block small">
                          <span className="text-muted">Kullanıcı:</span> <span className="fw-bold text-primary">{t.username}</span><br />
                          <span className="text-muted">Şifre:</span> <span className="fw-bold text-danger">{t.password}</span>
                        </div>
                      </td>
                      <td className="text-end pe-3"><button className="btn btn-sm btn-outline-danger fw-bold" onClick={() => handleDeleteFirebase("tesisler", t.id)}>Sil</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* YENİ FİNANSAL TAKİP MODÜLÜ */}
        {activeTab === 'finans' && (
          <div className="animate__animated animate__fadeIn">
            {/* Üst Filtreler */}
            <div className="card border-0 shadow-sm rounded-4 mb-4">
              <div className="card-body p-3 p-md-4 d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                <h4 className="fw-bold m-0 text-center text-md-start"><i className="fas fa-file-invoice-dollar text-primary me-2"></i>Finansal Takip Kartı</h4>
                <div className="d-flex gap-2 w-100 w-md-auto">
                  <select className="form-select border-0 bg-light fw-bold shadow-sm py-2 py-md-1" value={seciliYil} onChange={e => setSeciliYil(Number(e.target.value))}>
                    {yilListesi.map(y => <option key={y} value={y}>{y} Yılı</option>)}
                  </select>
                  <select className="form-select border-0 bg-light fw-bold shadow-sm py-2 py-md-1" value={seciliAy} onChange={e => setSeciliAy(Number(e.target.value))}>
                    {ayListesi.map((a, i) => <option key={i + 1} value={i + 1}>{a} Ayı</option>)}
                  </select>
                </div>
              </div>
            </div>

            {/* Ana Tablo */}
            <div className="card border-0 shadow-sm rounded-4 mb-4">
              <div className="table-responsive p-0">
                <table className="table table-hover align-middle m-0" style={{ minWidth: "1000px" }}>
                  <thead className="bg-dark text-white">
                    <tr>
                      <th className="py-3 ps-4" style={{ whiteSpace: 'nowrap' }}>HALI SAHA & SAHİBİ</th>
                      <th style={{ whiteSpace: 'nowrap' }}>İLETİŞİM</th>
                      <th style={{ whiteSpace: 'nowrap' }}>BEKLENEN ÜCRET</th>
                      <th style={{ whiteSpace: 'nowrap' }}>ALINAN ÖDEME</th>
                      <th style={{ whiteSpace: 'nowrap' }}>KALAN BORÇ</th>
                      <th style={{ whiteSpace: 'nowrap' }}>DURUM</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    {tesisler.filter(t => t.status === "approved").map(t => {
                      const pay = getPaymentForTesis(t.id);
                      const kalan = (Number(pay.beklenenFiyat) || 0) - (Number(pay.alinanOdeme) || 0);

                      return (
                        <tr key={t.id}>
                          <td className="ps-4">
                            <div className="fw-bold text-dark" style={{ whiteSpace: 'nowrap' }}>{t.fieldName}</div>
                            <small className="text-muted" style={{ whiteSpace: 'nowrap' }}>{t.name} {t.surname}</small>
                          </td>
                          <td>
                            <div className="small fw-bold text-primary">{t.phone}</div>
                          </td>
                          <td>
                            <div className="input-group input-group-sm" style={{ width: "120px" }}>
                              <input
                                type="number"
                                className="form-control border-light-subtle fw-bold"
                                value={pay.beklenenFiyat || ''}
                                onChange={e => handleUpdatePayment(t.id, 'beklenenFiyat', Number(e.target.value))}
                                placeholder="Fiyat..."
                              />
                              <span className="input-group-text bg-light">₺</span>
                            </div>
                          </td>
                          <td>
                            <div className="input-group input-group-sm" style={{ width: "120px" }}>
                              <input
                                type="number"
                                className="form-control border-light-subtle fw-bold text-success"
                                value={pay.alinanOdeme || ''}
                                onChange={e => handleUpdatePayment(t.id, 'alinanOdeme', Number(e.target.value))}
                                placeholder="Alınan..."
                              />
                              <span className="input-group-text bg-light text-success">₺</span>
                            </div>
                          </td>
                          <td>
                            <span className={`fw-bold ${kalan > 0 ? 'text-danger' : 'text-success'}`}>
                              {kalan.toLocaleString('tr-TR')} ₺
                            </span>
                          </td>
                          <td>
                            <select
                              className={`form-select form-select-sm fw-bold border-0 ${pay.durum === 'odendi' ? 'bg-success text-white' : pay.durum === 'kismi' ? 'bg-warning text-dark' : 'bg-danger text-white'}`}
                              value={pay.durum}
                              onChange={e => handleUpdatePayment(t.id, 'durum', e.target.value)}
                              style={{ width: "130px" }}
                            >
                              <option value="odenmedi">Ödenmedi</option>
                              <option value="kismi">Kısmi Ödeme</option>
                              <option value="odendi">Ödendi</option>
                            </select>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Muhasebe Özetleri */}
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card border-0 shadow-sm rounded-4 bg-primary text-white p-4">
                  <small className="opacity-75 fw-bold uppercase">SEÇİLİ AY TOPLAM CİRO ({ayListesi[seciliAy - 1]})</small>
                  <h2 className="display-6 fw-bold m-0">{aylikToplamCiro.toLocaleString('tr-TR')} ₺</h2>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card border-0 shadow-sm rounded-4 bg-dark text-white p-4">
                  <small className="opacity-75 fw-bold uppercase">{seciliYil} YILI TOPLAM CİRO</small>
                  <h2 className="display-6 fw-bold m-0 text-warning">{yillikToplamCiro.toLocaleString('tr-TR')} ₺</h2>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card border-0 shadow-sm rounded-4 bg-white border border-danger-subtle p-4">
                  <small className="text-danger fw-bold uppercase">TAHMİNİ VERGİ YÜKÜ (%20 KDV)</small>
                  <h2 className="display-6 fw-bold m-0 text-danger">-{kdvMiktari.toLocaleString('tr-TR')} ₺</h2>
                  <div className="mt-2 pt-2 border-top small text-muted">
                    Net Kar: <span className="fw-bold text-success">{(aylikToplamCiro - kdvMiktari).toLocaleString('tr-TR')} ₺</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* YENİ: GOL YÖNETİMİ TABI */}
        {activeTab === 'goller' && (
          <div className="animate__animated animate__fadeIn">
            <div className="card border-0 shadow-sm rounded-4">
              <div className="card-header bg-danger text-white p-4 border-bottom rounded-top-4 d-flex justify-content-between align-items-center">
                <h5 className="fw-bold m-0"><i className="fas fa-video me-2"></i>Atılan Golleri Yönet</h5>
                <span className="badge bg-white text-danger fw-bold">{goller.length} Video</span>
              </div>
              <div className="table-responsive p-3">
                <table className="table table-hover align-middle m-0" style={{ minWidth: "800px" }}>
                  <thead className="bg-light text-muted small">
                    <tr>
                      <th>VİDEO</th>
                      <th>YÜKLEYEN</th>
                      <th>TARİH</th>
                      <th className="text-center">BEĞENİ</th>
                      <th className="text-end">EYLEM</th>
                    </tr>
                  </thead>
                  <tbody>
                    {goller.map(g => (
                      <tr key={g.id}>
                        <td>
                          <video src={g.src} style={{ width: "120px", borderRadius: "8px", backgroundColor: "#000" }} muted />
                        </td>
                        <td style={{ minWidth: "200px" }}>
                          <div className="fw-bold text-dark">{g.name}</div>
                          <small className="text-muted">{g.userEmail}</small>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>{g.date}</td>
                        <td className="text-center fw-bold text-danger">
                          <i className="fas fa-heart me-1"></i> {g.likes || 0}
                        </td>
                        <td className="text-end">
                          <button className="btn btn-sm btn-outline-warning fw-bold px-3 py-2 me-2" onClick={() => handleBlockUser(g.userId, g.userEmail)}>
                            <i className="fas fa-ban me-1"></i> ENGELLE
                          </button>
                          <button className="btn btn-sm btn-outline-danger fw-bold px-3 py-2" onClick={() => handleDeleteFirebase("goller", g.id)}>
                            <i className="fas fa-trash-alt me-1"></i> SİL
                          </button>
                        </td>
                      </tr>
                    ))}
                    {goller.length === 0 && (
                      <tr><td colSpan="5" className="text-center p-5 text-muted fw-bold">Henüz yüklenmiş gol bulunamadı.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* ENGELLENEN KULLANICILAR LİSTESİ */}
            <div className="card border-0 shadow-sm rounded-4 mt-4">
              <div className="card-header bg-dark text-white p-4 border-bottom rounded-top-4">
                <h5 className="fw-bold m-0"><i className="fas fa-user-slash me-2"></i>Engellenen Kullanıcılar</h5>
              </div>
              <div className="table-responsive p-3">
                <table className="table table-hover align-middle m-0">
                  <thead className="bg-light text-muted small">
                    <tr>
                      <th>E-POSTA</th>
                      <th>ENGEL TARİHİ</th>
                      <th className="text-end">EYLEM</th>
                    </tr>
                  </thead>
                  <tbody>
                    {blockedUsers.map(u => (
                      <tr key={u.id}>
                        <td>{u.userEmail}</td>
                        <td>{u.blockedAt?.toDate().toLocaleDateString('tr-TR')}</td>
                        <td className="text-end">
                          <button className="btn btn-sm btn-success fw-bold" onClick={() => handleUnblockUser(u.id)}>
                            ENGELİ KALDIR
                          </button>
                        </td>
                      </tr>
                    ))}
                    {blockedUsers.length === 0 && (
                      <tr><td colSpan="3" className="text-center p-3 text-muted">Engellenen kimse yok.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* YENİ: KAYITLI KULLANICILAR TABI */}
        {activeTab === 'users' && (
          <div className="animate__animated animate__fadeIn">
            <div className="card border-0 shadow-sm rounded-4">
              <div className="card-header bg-primary text-white p-4 border-bottom rounded-top-4 d-flex justify-content-between align-items-center">
                <h5 className="fw-bold m-0"><i className="fas fa-users me-2"></i>Kayıtlı Kullanıcılar Listesi</h5>
                <span className="badge bg-white text-primary fw-bold">{users.length} Kullanıcı</span>
              </div>
              <div className="table-responsive p-3">
                <table className="table table-hover align-middle m-0">
                  <thead className="bg-light text-muted small">
                    <tr>
                      <th>KULLANICI ADI</th>
                      <th>E-POSTA</th>
                      <th>SON GİRİŞ</th>
                      <th className="text-end">EYLEM</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map(u => {
                      const profile = userProfiles[u.id];
                      return (
                      <tr key={u.id}>
                        <td className="fw-bold text-primary">
                          {profile?.username ? `@${profile.username}` : <span className="text-muted fst-italic">Belirlemedi</span>}
                        </td>
                        <td>{u.email}</td>
                        <td>{u.lastLogin?.toDate().toLocaleString('tr-TR')}</td>
                        <td className="text-end">
                          <button className="btn btn-sm btn-outline-danger border-0" onClick={() => handleDeleteUser(u.id, u.email)}>
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </td>
                      </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}





        {/* YENİ: SAHA SAHİPLERİ YÖNETİMİ TABI */}
        {activeTab === 'sahipler' && (
          <div className="animate__animated animate__fadeIn">
            <div className="card border-0 shadow-sm rounded-4 mb-4">
              <div className="card-header bg-warning text-dark p-4 border-bottom rounded-top-4">
                <h5 className="fw-bold m-0"><i className="fas fa-user-plus me-2"></i>Yeni Saha Sahibi Yetkilendir</h5>
              </div>
              <div className="card-body p-4">
                <form onSubmit={handleAddSahaOwner} className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Halı Saha Adı</label>
                    <input type="text" className="form-control bg-light border-0" placeholder="Örn: Şampiyon Halı Saha" value={newSahaName} onChange={e => setNewSahaName(e.target.value)} required />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Sahibi E-Posta Adresi</label>
                    <input type="email" className="form-control bg-light border-0" placeholder="sahibi@example.com" value={newSahaEmail} onChange={e => setNewSahaEmail(e.target.value)} required />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Sahibi Telefon</label>
                    <input type="tel" className="form-control bg-light border-0" placeholder="05xx..." value={newSahaPhone} onChange={e => setNewSahaPhone(e.target.value)} required />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Sahibi Adı</label>
                    <input type="text" className="form-control bg-light border-0" placeholder="Ad" value={newSahaFirstName} onChange={e => setNewSahaFirstName(e.target.value)} required />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Sahibi Soyadı</label>
                    <input type="text" className="form-control bg-light border-0" placeholder="Soyad" value={newSahaLastName} onChange={e => setNewSahaLastName(e.target.value)} required />
                  </div>
                  <div className="col-md-4 d-flex align-items-end">
                    <button type="submit" className="btn btn-dark w-100 py-2 fw-bold shadow-sm" disabled={isAddingSaha}>
                      {isAddingSaha ? "Ekleniyor..." : "YETKİLENDİR VE DAVET ET"}
                    </button>
                  </div>
                </form>
                <div className="mt-2 text-muted extra-small">
                  <i className="fas fa-info-circle me-1"></i> Yetkilendirilen e-posta adresi, OTP kodu ile sisteme giriş yapabilecek ve ardından kendi şifresini belirleyebilecektir.
                </div>
              </div>
            </div>

            <div className="card border-0 shadow-sm rounded-4">
              <div className="card-header bg-dark text-white p-4 border-bottom rounded-top-4">
                <h5 className="fw-bold m-0"><i className="fas fa-users-cog me-2"></i>Yetkili Saha Sahipleri Listesi</h5>
              </div>
              <div className="table-responsive p-3">
                <table className="table table-hover align-middle m-0">
                  <thead className="bg-light text-muted small">
                    <tr>
                      <th>SAHA ADI</th>
                      <th>SAHİBİ & İLETİŞİM</th>
                      <th>PANEL DURUMU</th>
                      <th className="text-end">EYLEM</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tesisler.map(t => (
                      <tr key={t.id}>
                        <td className="fw-bold">{t.fieldName}</td>
                        <td>
                          <div className="small fw-bold">{t.name} {t.surname}</div>
                          <div className="extra-small text-muted">{t.email} | {t.phone}</div>
                        </td>
                        <td>
                          {t.username ? (
                            <span className="badge bg-success"><i className="fas fa-check me-1"></i> Aktif (Şifre Belirlendi)</span>
                          ) : (
                            <span className="badge bg-warning text-dark"><i className="fas fa-clock me-1"></i> Bekliyor (Henüz Girmedi)</span>
                          )}
                        </td>
                        <td className="text-end">
                          <button className="btn btn-sm btn-outline-danger border-0" onClick={() => handleDeleteFirebase("tesisler", t.id)}>
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                    {tesisler.length === 0 && (
                      <tr><td colSpan="4" className="text-center p-3 text-muted">Yetkili saha bulunamadı.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* YENİ: SÜPER ADMİN YÖNETİMİ TABI */}
        {activeTab === 'superadmins' && (
          <div className="animate__animated animate__fadeIn">
            <div className="card border-0 shadow-sm rounded-4 mb-4">
              <div className="card-header bg-warning text-dark p-4 border-bottom rounded-top-4">
                <h5 className="fw-bold m-0"><i className="fas fa-users-cog me-2"></i>Yeni Süper Admin Ekle</h5>
              </div>
              <div className="card-body p-4">
                <form onSubmit={handleAddSuperAdmin} className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Kullanıcı Adı</label>
                    <input type="text" className="form-control bg-light border-0" placeholder="Kullanıcı Adı" value={newAdminUsername} onChange={e => setNewAdminUsername(e.target.value)} required />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">E-Posta Adresi</label>
                    <input type="email" className="form-control bg-light border-0" placeholder="admin@sahalive.com" value={newAdminEmail} onChange={e => setNewAdminEmail(e.target.value)} required />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Şifre</label>
                    <input type="password" className="form-control bg-light border-0" placeholder="Şifre" value={newAdminPassword} onChange={e => setNewAdminPassword(e.target.value)} required />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Adı</label>
                    <input type="text" className="form-control bg-light border-0" placeholder="Ad" value={newAdminName} onChange={e => setNewAdminName(e.target.value)} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Soyadı</label>
                    <input type="text" className="form-control bg-light border-0" placeholder="Soyad" value={newAdminSurname} onChange={e => setNewAdminSurname(e.target.value)} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-bold">Özel Kod (2FA)</label>
                    <input type="text" className="form-control bg-light border-0" placeholder="Örn: 145325" value={newAdminCode} onChange={e => setNewAdminCode(e.target.value)} required />
                  </div>
                  <div className="col-md-12 text-end">
                    <button type="submit" className="btn btn-dark py-2 px-4 fw-bold shadow-sm" disabled={isAddingAdmin}>
                      {isAddingAdmin ? "Ekleniyor..." : "SÜPER ADMİN EKLE"}
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="card border-0 shadow-sm rounded-4">
              <div className="card-header bg-dark text-white p-4 border-bottom rounded-top-4">
                <h5 className="fw-bold m-0"><i className="fas fa-users-cog me-2"></i>Aktif Süper Adminler Listesi</h5>
              </div>
              <div className="table-responsive p-3">
                <table className="table table-hover align-middle m-0">
                  <thead className="bg-light text-muted small">
                    <tr>
                      <th>KULLANICI ADI & AD SOYAD</th>
                      <th>E-POSTA ADRESİ</th>
                      <th>ÖZEL KOD (2FA)</th>
                      <th className="text-end">EYLEM</th>
                    </tr>
                  </thead>
                  <tbody>
                    {superadmins.map(admin => (
                      <tr key={admin._id}>
                        <td>
                          <div className="fw-bold text-dark">@{admin.username}</div>
                          <small className="text-muted">{admin.name} {admin.surname}</small>
                        </td>
                        <td className="fw-bold">{admin.email}</td>
                        <td>
                          <span className="badge bg-secondary px-3 py-2 fw-bold" style={{ letterSpacing: '2px' }}>{admin.superadminCode || '145325'}</span>
                        </td>
                        <td className="text-end">
                          <button 
                            className="btn btn-sm btn-outline-danger border-0" 
                            onClick={() => handleDeleteSuperAdmin(admin._id, admin.email)}
                            disabled={admin.email === 'suerdemahmetsami7@gmail.com'}
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SuperAdmin;